export const getCityOptionTitle = (cityId: number | string, cityName: string): string =>
	cityName ? `${cityName} (ID: ${cityId})` : `${cityId}`;
